import React, { useEffect, useRef, useState } from "react";
import AgreementInk from "./AgreementInk";
export default function AgreementPdfPage({
  document,
  pageNumber,
  strokes,
  onChange,
  color,
  disabled,
  onPageError,
}) {
  const canvas = useRef(null);
  const [size, setSize] = useState({ width: 800, height: 1000 });
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false,
      task;
    document
      .getPage(pageNumber)
      .then((page) => {
        if (cancelled) return;
        const original = page.getViewport({ scale: 1 });
        const viewport = page.getViewport({
          scale: Math.min(1.5, 1000 / original.width),
        });
        setSize({ width: viewport.width, height: viewport.height });
        canvas.current.width = viewport.width;
        canvas.current.height = viewport.height;
        task = page.render({
          canvasContext: canvas.current.getContext("2d"),
          viewport,
        });
        return task.promise;
      })
      .catch((error) => {
        if (!cancelled) {
          setError(
            "Could not render this page. Reopen the agreement before signing.",
          );
          onPageError?.();
        }
      });
    return () => {
      cancelled = true;
      task?.cancel();
    };
    // The error callback only marks the parent editor unavailable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document, pageNumber]);
  return (
    <section className="mb-6">
      <p className="text-sm text-gray-500 mb-2">Page {pageNumber}</p>
      {error && (
        <p role="alert" className="text-red-700">
          {error}
        </p>
      )}
      <div
        className="relative bg-white shadow border rounded"
        style={{ aspectRatio: `${size.width}/${size.height}` }}
      >
        <canvas
          ref={canvas}
          style={{ width: "100%", height: "100%", display: "block" }}
        />
        <div className="absolute inset-0">
          <AgreementInk
            page={pageNumber - 1}
            strokes={strokes.filter((stroke) => stroke.page === pageNumber - 1)}
            color={color}
            width={size.width}
            height={size.height}
            disabled={disabled || !!error}
            onChange={(pageStrokes) =>
              onChange([
                ...strokes.filter((stroke) => stroke.page !== pageNumber - 1),
                ...pageStrokes,
              ])
            }
          />
        </div>
      </div>
    </section>
  );
}
